import { CircularProgress, Stack, Typography } from '@mui/material';

export default function AuthenticatingUser() {
  return (
    <Stack
      sx={{
        justifyContent: 'center',
        alignItems: 'center',
      }}
      spacing={2}
    >
      <CircularProgress variant='indeterminate' />
      <Typography
        component='h1'
        variant='h5'
        sx={{ fontWeight: 600, textAlign: 'center' }}
      >
        Autentikoidaan käyttäjää...
      </Typography>
    </Stack>
  );
}
